import { Badge } from "@workspace/web-ui/components/badge"
import { format } from "date-fns"
import { CalendarEvent } from "../../../components"

interface RefillCardProps {
  appointment: CalendarEvent & {
    status?: 'pending' | 'rejected' | 'accepted'
  }
  onSelectRefill: (id: string) => void
}

const formatTimeRange = (start: Date, end: Date) => {
  return `${format(start, "h:mm a")} - ${format(end, "h:mm a")}`
}

export function RefillCard({ appointment, onSelectRefill }: RefillCardProps) {

  const handleClick = () => {
    onSelectRefill(appointment.id);
  };

  return (
    <div
      onClick={handleClick}
      className={`p-8 rounded-md max-w-[800px] flex flex-col cursor-pointer
        ${appointment.status === "pending"
          ? "border border-[#4272DD] bg-[#4272DD] text-white"
          : appointment.status === "rejected"
            ? "bg-[#ECECED] border border-white text-[#2D2F35]"
            : "bg-white border border-[#4272DD] text-[#2D2F35]" // accepted
        }`}
    >
      <div className="flex items-center space-x-3 mb-1">
        <p className="font-medium">Refill Request: {appointment.title}</p>
        <Badge 
          className={`rounded-full px-2 text-xs font-medium capitalize
            ${appointment.status === "pending"
              ? "text-[#4272DD] bg-white border border-gray-300 hover:bg-gray-300"
              : appointment.status === "rejected"
                ? "text-[#2D2F35] hover:bg-transparent bg-white border border-white"
                : "text-[#4272DD] hover:bg-transparent bg-transparent border border-[#4272DD]" // accepted
            }`}
        >
          {appointment.status}
        </Badge>
      </div>
      <p className="text-sm">{formatTimeRange(appointment.start, appointment.end)}</p>
    </div>
  )
}